// Generated from line_plot_settings.v1.json
// DO NOT EDIT MANUALLY

import {z} from 'zod';


export const linePlotTemplateSettingsSchema = z.object({
"colorRunNames": z.boolean().describe("Whether run names should be colored in panel tooltips").optional(),
"coordinateZooming": z.boolean().describe("Whether user zoom interaction is synced across panels").optional(),
"displayFullRunName": z.boolean().describe("No crop option for chart legends to accommodate long run names with crucial information in the middle").optional(),
"excludeOutliers": z.enum(["include-outliers",
"exclude-outliers"]).describe("Whether to include or exclude outliers in the chart").optional(),
"groupAgg": z.enum(["last",
"max",
"mean",
"median",
"min",
"samples",
"sum"]).describe("Aggregation method for grouped runs").optional(),
"highlightedCompanionRunOnly": z.boolean().describe("If true, only show the highlighted run in companion plots").optional(),
"maxRuns": z.number().int().gte(1).describe("Maximum number of runs to display").optional(),
"pointVisualizationMethod": z.enum(["bucketing-gorilla",
"sampling",
"sampling-by-default"]).describe("Default point visualization method for runs line plots").optional(),
"showLegend": z.boolean().describe("Whether the legend is shown in charts").optional(),
"showOriginalAfterSmoothing": z.boolean().describe("Show the original line in addition to the smoothed line").optional(),
"showXRange": z.boolean().describe("Whether the x bucket range is shown in the tooltip on hover").optional(),
"smoothingWeight": z.number().describe("Weight for smoothing algorithm").optional(),
"smoothingType": z.enum(["average",
"exponential",
"exponentialTimeWeighted",
"gaussian",
"none"]).describe("Type of smoothing to apply").optional(),
"tooltipNumberOfRuns": z.enum(["single",
"default",
"all_runs"]).describe("Determines how many runs are displayed in panel tooltips").optional(),
"useRunsTableGroupingInPanels": z.boolean().describe("Whether to use runs table grouping in panels").optional(),
"xAxis": z.string().describe("The metric or dimension to plot on X axis (e.g. '_step', '_runtime', '_timestamp', '_absolute_runtime', or custom metric)").optional(),
"xLogScale": z.boolean().describe("Whether to use logarithmic scale on X axis").optional(),
"xAxisMin": z.number().describe("Minimum value for X axis").optional(),
"xAxisMax": z.number().describe("Maximum value for X axis").optional(),
"xAxisFormat": z.enum(["number",
"datetime"]).describe("Format for X axis values (i.e. 'number' or 'datetime')").optional(),
"yLogScale": z.boolean().describe("Whether to use logarithmic scale on Y axis").optional(),
"yAxisMin": z.number().describe("Minimum value for Y axis").optional(),
"yAxisMax": z.number().describe("Maximum value for Y axis").optional()
}).strict().describe("Subset of line plot settings that are saved in workspace templates")


export type LinePlotSettingsV1 = z.infer<typeof linePlotTemplateSettingsSchema>;
